import { render, staticRenderFns } from "./PromotionInvitationConfigForm.vue?vue&type=template&id=bed2567e"
import script from "./PromotionInvitationConfigForm.vue?vue&type=script&lang=js"
export * from "./PromotionInvitationConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports